async function request(path, options = {}) {
  const response = await fetch(path, {
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
    ...options,
  });

  const payload = await response.json().catch(() => ({}));
  if (!response.ok || payload.success === false) {
    throw new Error(payload.error || payload.message || 'Request failed.');
  }

  return payload;
}

export const platformAPI = {
  register(payload) {
    return request('/api/auth/register', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  },

  login(payload) {
    return request('/api/auth/login', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  },

  logout() {
    return request('/api/auth/logout', {
      method: 'POST',
      body: JSON.stringify({}),
    });
  },

  getCurrentMember() {
    return request('/api/member/me');
  },

  getCloudflareCredential() {
    return request('/api/member/cloudflare-token');
  },

  saveCloudflareCredential(payload) {
    return request('/api/member/cloudflare-token', {
      method: 'PUT',
      body: JSON.stringify(payload),
    });
  },

  deleteCloudflareCredential() {
    return request('/api/member/cloudflare-token', {
      method: 'DELETE',
    });
  },

  createApiKey(name) {
    return request('/api/member/api-keys', {
      method: 'POST',
      body: JSON.stringify({ name }),
    });
  },

  revokeApiKey(keyId) {
    return request(`/api/member/api-keys/${keyId}`, {
      method: 'DELETE',
    });
  },

  createSuperVip(payload) {
    return request('/api/admin/super-vip', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  },

  resetMemberPassword(payload) {
    return request('/api/admin/member-password', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  },

  bootstrapSuperAdminPassword(payload) {
    return request('/api/admin/bootstrap-password', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  },
};
